import { render, staticRenderFns } from "./AboutFrame.vue?vue&type=template&id=06be6172&scoped=true&"
import script from "./AboutFrame.vue?vue&type=script&lang=js&"
export * from "./AboutFrame.vue?vue&type=script&lang=js&"
import style0 from "./AboutFrame.vue?vue&type=style&index=0&id=06be6172&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06be6172",
  null
  
)

export default component.exports